/* ══ STICKY HEADER PATCH v2 ══ */
(function() {
  function patchStickyHeader() {
    if (typeof BlsMainMenuShopify === 'undefined') {
      setTimeout(patchStickyHeader, 100);
      return;
    }

    const header = document.querySelector('header');
    if (!header) return;

    const sticky = header.getAttribute('data-sticky');
    const sticky_mobile = header.getAttribute('data-sticky-mobile');

    if (sticky === 'none') return;
    if (sticky_mobile === 'false' && window.innerWidth < 1025) return;

    const sec_header = header.closest('.section-header');
    if (!sec_header) return;

    const headerSpaceH = document.getElementById('header-sticky')?.offsetHeight || 0;
    const announcement_bar = document.querySelector('.section-announcement-bar')?.clientHeight || 0;
    const top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
    const headerh = announcement_bar + top_bar + headerSpaceH;

    // State tracking - مش هنلمس DOM إلا لو في تغيير فعلي
    let isSticky = false;
    let isHidden = false;
    let lastScrollY = window.scrollY;
    let ticking = false;

    function updateHeader() {
      const wpy = window.scrollY;

      if (sticky === 'always') {
        const shouldBeSticky = wpy > headerh;
        if (shouldBeSticky !== isSticky) {
          isSticky = shouldBeSticky;
          if (shouldBeSticky) {
            sec_header.classList.add('shopify-section-header-sticky', 'animate');
          } else {
            sec_header.classList.remove('shopify-section-header-sticky', 'animate');
          }
        }

      } else {
        // on-scroll-up mode
        if (wpy > headerh) {
          if (!isSticky) {
            isSticky = true;
            sec_header.classList.add('header-sticky', 'shopify-section-header-sticky', 'scr-pass-header');
          }

          const scrollingDown = wpy > lastScrollY;
          const scrollingUp = wpy < lastScrollY;

          if (scrollingDown && !isHidden) {
            isHidden = true;
            sec_header.classList.add('shopify-section-header-hidden');
            sec_header.classList.remove('animate');
          } else if (scrollingUp && isHidden) {
            isHidden = false;
            sec_header.classList.remove('shopify-section-header-hidden');
            sec_header.classList.add('animate');
          }

        } else if (wpy <= 0) {
          if (isSticky) {
            isSticky = false;
            isHidden = false;
            sec_header.classList.remove(
              'shopify-section-header-hidden',
              'header-sticky',
              'animate',
              'shopify-section-header-sticky',
              'scr-pass-header'
            );
          }
        }

        lastScrollY = wpy;
      }

      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (header.classList.contains('open-submenu')) return;
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });

    // إيقاف الكود القديم
    BlsMainMenuShopify.updateStickyHeader = function() {};
    BlsMainMenuShopify.initStickyHeader = function() {};
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchStickyHeader);
  } else {
    patchStickyHeader();
  }
})();